// extracted by mini-css-extract-plugin
export default {"total":"App_total__RIkka","title":"App_title__wJw7v","list":"App_list__mV0jV"};